import { render, staticRenderFns } from "./RequestAnAssignment.vue?vue&type=template&id=77e00f5a&scoped=true&"
import script from "./RequestAnAssignment.vue?vue&type=script&lang=js&"
export * from "./RequestAnAssignment.vue?vue&type=script&lang=js&"
import style0 from "./RequestAnAssignment.vue?vue&type=style&index=0&id=77e00f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e00f5a",
  null
  
)

export default component.exports